module.exports = __webpack_public_path__ + "static/img/erweima.11fd5f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/erweima.png
// module id = Dd/9
// module chunks = 33